/**
 * @generated SignedSource<<4c91998601deb410f355b2c5e1f6d31f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsHeaderFragment_club$data = {
  readonly copyOverrides: {
    readonly event: {
      readonly singular: string;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly slug: string;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
  readonly " $fragmentType": "EventsHeaderFragment_club";
};
export type EventsHeaderFragment_club$key = {
  readonly " $data"?: EventsHeaderFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsHeaderFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventsHeaderFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClubLogo_Club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "4fd4ab8183b11df3f6e037909bea5f58";

export default node;
